// drag_n_drop_properties.js
jQuery(document).ready(function () {
    // Drag and drop functionality
    jQuery('#sortA').sortable({
        receive: function (event, ui) {
            jQuery.post(jQuery(this).data('delete-url'), jQuery(this).sortable('serialize'));
            event.preventDefault();
        },
        connectWith: ".sortable",
        appendTo: 'body'
    }).disableSelection();

    jQuery('#sortB').sortable({
        receive: function (event, ui) {
            jQuery.post(jQuery(this).data('create-url'), jQuery(this).sortable('serialize'));
            event.preventDefault();
        },
        update: function (event, ui) {
            jQuery.post(jQuery(this).data('update-url'), jQuery(this).sortable('serialize'));
        },
        connectWith: ".sortable",
        appendTo: 'body'
    }).disableSelection();

    // Search functionality
    jQuery.expr[":"].contains = jQuery.expr.createPseudo(function (arg) {
        return function (elem) {
            return jQuery(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
        };
    });

    jQuery("#search_participant_properties").keyup(function () {
        var searchText = jQuery(this).val();

        jQuery('.participant-properties').hide();
        var selector = '.participant-properties:contains("' + searchText + '")';
        jQuery(selector).each(function () {
            jQuery(this).show();
        });
    });

    jQuery("#search_participant_form_settings").keyup(function () {
        var searchText = jQuery(this).val();

        jQuery('.participant-form-settings').hide();
        var selector = '.participant-form-settings:contains("' + searchText + '")';
        jQuery(selector).each(function () {
            jQuery(this).show();
        });
    });
});
